/**
 * Created by heweiguang on 2019-07-15.
 */

export function noop() {}
